// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 453 ? "eef9e134" : chunkId) + "." + {"48":"745620e058471185","163":"6f26f57f45d21c9e","324":"ee0d818db5e99f98","337":"2235fadc93788e32","394":"3b4dd93a59016a8c","453":"5d780324daf21333","851":"741e1a3fbcf3cc01","856":"fd332b32236a1723","997":"1c78817b97070af8"}[chunkId] + ".js";
};